module.exports = __webpack_public_path__ + "img/kefu_left.9406330a.jpg";